<template>
  <div>
    <Dashboard />
  </div>
</template>

<script>
import Dashboard from '@/nfmp_components/Dashboard.vue'
export default {
  components: {
    Dashboard
  }
}
</script>